import classes from "./index.module.css";
import { Alert } from "@/components/Icons";
import { PropsWithChildren } from "react";

interface ValidationErrorProps extends PropsWithChildren {
  withAlert?: boolean;
}

export const ValidationError = ({ children, withAlert = true }: ValidationErrorProps) => {
  return children && typeof children !== "boolean" ? (
    <span className={classes.errorWrapper}>
      {withAlert && <Alert fontSize={18} />}
      {children}
    </span>
  ) : null;
};
